import { CardItem } from '@/components/Card/Card';
import Stack from '@/design_system/Stack';
import { useBrandRequestContext } from '@/layouts/Brand/BrandRequestContext';
import { ArticleActionWithRelations, ArticleWithRelations } from '@/models/request';
import useViewPort from '@/utils/useViewport';

import { DefectName } from './DefectName';
import { DefectNotUnderBrandResponsibility } from './DefectNotUnderBrandResponsibility';
import { ExceptionalBrandCoverage } from './ExceptionalBrandCoverage';

export const ActionDefects = ({
  action,
  isDisabled = false,
  isPreviousAction = false,
  article,
}: {
  action: ArticleActionWithRelations;
  isDisabled?: boolean;
  isPreviousAction?: boolean;
  article: ArticleWithRelations;
}) => {
  const { isMobile } = useViewPort();
  const { view } = useBrandRequestContext();

  const articleDefects =
    (isPreviousAction
      ? article.previousSnapshot?.articleDefects
      : article.snapshot.articleDefects) ?? [];

  const defects = articleDefects.filter((defect) =>
    action.articleActionToArticleDefects.some(
      ({ articleDefectId }) => articleDefectId === defect.id
    )
  );

  if (isMobile) {
    return (
      <Stack row gap="0.25rem">
        {defects.map((defect) => (
          <CardItem key={defect.id} style={{ flexGrow: 0 }}>
            <DefectName isDisabled={isDisabled} defect={defect} article={article} />
            {view.articles.defects.brandResponsibility.shown(article) &&
              !defect.brandResponsibility && <DefectNotUnderBrandResponsibility />}
            {view.articles.defects.brandResponsibility.exceptionalCoverage.shown &&
              defect.brandResponsibility &&
              defect.exceptionalBrandResponsibilityCoverageRequested && (
                <ExceptionalBrandCoverage article={article} defect={defect} />
              )}
          </CardItem>
        ))}
      </Stack>
    );
  }

  return (
    <Stack>
      {defects.map((defect) => (
        <div key={defect.id}>
          <DefectName defect={defect} isDisabled={isDisabled} article={article} />
          {view.articles.defects.brandResponsibility.shown(article) &&
            !defect.brandResponsibility && <DefectNotUnderBrandResponsibility />}
          {view.articles.defects.brandResponsibility.exceptionalCoverage.shown &&
            defect.brandResponsibility &&
            defect.exceptionalBrandResponsibilityCoverageRequested && (
              <ExceptionalBrandCoverage article={article} defect={defect} />
            )}
        </div>
      ))}
    </Stack>
  );
};
